import { JSX, ReactNode } from 'react'

import { PiUpload } from 'react-icons/pi'

import { FileUpload, Button, Image as ChakraImage } from '@chakra-ui/react'


import * as detective from '@/lib/detective.js'


import * as dialog from './dialog.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Avatar from './avatar.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Trigger
(props: { children?: ReactNode }): JSX.Element
{
	return (
		<FileUpload.Trigger asChild>
			<Button p="1" h="9" w="fit-content" variant="ghost" rounded="md">
				{props.children}

			</Button>
		</FileUpload.Trigger>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Upload
(
	props: {
		accept   : string
		limit?   : number
		children?: ReactNode

		select(files: File[]): void

	},

)
:	JSX.Element
{
	let on_select = (details: { files: File[] }): void =>
	{
		props.select(details.files)

	}

	return (
		<FileUpload.Root maxFiles={props.limit} onFileAccept={on_select}>
			<FileUpload.HiddenInput />

			<Trigger>
				{props.children ?? <PiUpload color="fg.muted" />}

			</Trigger>

		</FileUpload.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Image
(
	props: {
		thumbnail: string
		original?: string | ( () => Promise<string>)

		change(files: File): void

	},

)
:	JSX.Element
{
	if (detective.is_empty(props.thumbnail) )
	{
		let on_select = ([file]: File[]): void =>
		{
			props.change(file)

		}

		return (
			<Upload accept="image/*" select={on_select}>
				<PiUpload color="fg.muted" />

			</Upload>

		)

	}

	if (detective.is_empty(props.original) )
	{
		return (
			<Avatar.Single ml="1" size="xs" shape="rounded" src={props.thumbnail} />

		)

	}

	let on_open = async (): Promise<void> =>
	{
		let src = ''

		if (detective.is_string(props.original) )
		{
			src = props.original

		}

		else if (detective.is_function(props.original) )
		{
			src = await props.original()

		}


		dialog.open(
			<ChakraImage rounded="md" src={src} />,

		)

	}

	return (
		<Avatar.Single ml="1" size="xs" cursor="pointer" shape="rounded" src={props.thumbnail} onClick={on_open} />

	)

}
